export default __webpack_public_path__ + "static/media/Solana.9b4dac4a.png";